import React, { useCallback, useMemo, useRef } from 'react';
import { RemoteControl } from 'components/remote-control.js';

export default PanelButton;

function PanelButton (props) {
  const {
    name,
    onClick,
    onActive,
    onInactive,
    className,
  } = props;
  /**
   *
   * @type {React.MutableRefObject<HTMLElement>}
   */
  const ref = useRef();

  const id = useMemo(() => `emoji_${name}`, [name]);
  const removeIsClicked = useCallback(() => {
    delete ref.current.dataset.clicked;
  }, []);
  const onOver = useCallback(() => {
    onActive(name);
  }, [name, onActive]);
  const onLeave = useCallback(() => {
    onInactive(name);
  }, [name, onInactive]);

  const onClickButton = useCallback(() => {
    ref.current.dataset.clicked = 'clicked';
    onClick(name);
  }, [name, onClick]);

  const onFocused = useCallback(() => {
    onActive(name);
  }, [onActive, name]);
  const onBlurred = useCallback(() => {
    onInactive(name);
  }, [onInactive, name]);

  return (
    <RemoteControl id={id} onOver={onOver} onLeave={onLeave}>
      <button
        id={id}
        onAnimationEnd={removeIsClicked}
        onClick={onClickButton}
        className={className}
        onFocus={onFocused}
        onBlur={onBlurred}
      >
        <div ref={ref}>
          {props.children}
        </div>
      </button>
    </RemoteControl>
  );
}
